import React from 'react';
import '../styles/Hero.css';

const Hero = () => {
  const scrollToProducts = () => {
  const element = document.getElementById('chocolate-cakes'); // Changed from 'cakes'
  if (element) {
    const offset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-shape hero-shape-1"></div>
        <div className="hero-shape hero-shape-2"></div>
        <div className="hero-shape hero-shape-3"></div>
      </div>
      
      <div className="hero-container">
        <div className="hero-content fade-in">
          <h1 className="hero-title">
            Handcrafted with
            <span className="highlight"> Love</span>
          </h1>
          <p className="hero-subtitle">
            Indulge in our premium collection of cakes, jar cakes, and brownies.
            Made fresh to order with the finest ingredients.
          </p>
          <div className="hero-buttons">
            <button onClick={scrollToProducts} className="btn btn-primary">
              Explore Menu
            </button>
            <a href="#about-preview" className="btn btn-outline">
              Our Story
            </a>
          </div>
          
          <div className="hero-features">
            <div className="feature-item">
              <span className="feature-icon">🎂</span>
              <span className="feature-text">Fresh Daily</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🌟</span>
              <span className="feature-text">Premium Quality</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📦</span>
              <span className="feature-text">Made to Order</span>
            </div>
          </div>
        </div>
        
        <div className="hero-image scale-in">
          <div className="hero-image-wrapper">
            <img 
              // src="https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=800&h=800&fit=crop&q=80" 
              src="https://plus.unsplash.com/premium_photo-1715015439764-1e8d37d5c6c9?w=800&h=800&fit=crop&q=80" 
              
              alt="Delicious Cakified Cake"
            />
            <div className="image-decoration"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
